import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import { Navbar } from "./navbar/Navbar";
import { ScrollToTop } from "../components/ScrollToTop";

export function MainContentLayout() {

  return (
    <div className="flex md:flex-row h-screen bg-background">
      <ScrollToTop />
      <Navbar />
      <Sidebar />
      <div className="flex flex-col flex-1 mt-14 md:mt-14">
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
